import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Filelister.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Filesmanager from '../views/Filesmanager.vue'
import Cache from '../views/Cache.vue'
import Setting from '../views/Setting.vue'
import SiteSetting from '../views/setting/SiteSetting.vue'
import DrivesSetting from '../views/setting/DrivesSetting.vue'
import PasswordSetting from '../views/setting/PasswordSetting.vue'
import DevSetting from '../views/setting/DevSetting.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  }, {
    path: '/files',
    name: 'Files',
    component: Filesmanager
  }, {
    path: '/cache',
    name: 'Cache',
    component: Cache
  }, {
    path: '/setting*',
    component: Setting,
    children: [
      {
        path: 'site',
        component: SiteSetting
      },
      {
        path: 'drives',
        component: DrivesSetting
      },
      {
        path: 'password',
        component: PasswordSetting
      },
      {
        path: 'dev',
        component: DevSetting
      }
    ]
  }, {
    path: '/home*',
    name: 'Home',
    component: Home
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/*',
    name: 'Home1',
    component: Home
  },
]

const router = new VueRouter({
  routes
})

export default router
